module.exports = __webpack_public_path__ + "static/media/no-search-results.6b81659e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/no-search-results.svg
// module id = 707
// module chunks = 0